import * as React from 'react';
import { Header3, InlineText1, Paragraph1 } from '@cian/ui-kit';
import { IAvailableJk } from '../../../../types/newbuilding/promos';
import * as styles from './JKList.css';

interface IJKListProps {
  jkList: IAvailableJk[];
  onJkClick?(jk: IAvailableJk, index: number): void;
}

export function JKList({ jkList, onJkClick }: IJKListProps) {
  return (
    <>
      <div className={styles['subtitle']}>
        <Header3>Акция проходит так же в ЖК:</Header3>
      </div>
      <Paragraph1>
        {jkList.map((jk, idx) => (
          <React.Fragment key={jk.link}>
            <a
              className={styles['jk-link']}
              href={jk.link}
              onClick={() => onJkClick && onJkClick(jk, idx)}
              target="blank"
              rel="noopener"
            >
              <InlineText1 color="primary_100">{jk.name}</InlineText1>
            </a>
            {idx < jkList.length - 1 && ', '}
          </React.Fragment>
        ))}
      </Paragraph1>
    </>
  );
}
